export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '/api';
export const API_TIMEOUT = Number(import.meta.env.VITE_API_TIMEOUT) || 300_000;
export const AI_ENDPOINT_URL = import.meta.env.VITE_AI_ENDPOINT_URL ?? 'https://ia.clickpalm.com/';
export const AI_ENDPOINT_FALLBACK_URL = import.meta.env.VITE_AI_ENDPOINT_FALLBACK_URL ?? 'https://ia.clickpalm.com/chat/general';
export const AI_ASSISTANT_ID = import.meta.env.VITE_AI_ASSISTANT_ID ?? '';
// Origen del mapa que se embebe en iframe. En desarrollo debe apuntar a
// mapsdev, que lee ClickPalmBDDev; el valor por defecto es el de producción.
export const MAPS_BASE_URL = import.meta.env.VITE_MAPS_BASE_URL ?? 'https://maps.clickpalm.com';
// Carpeta de los assets de El Cerebro (`public/brain`), que produce
// `ClickPalmAPI/tools/palm-training/export_brain.py`. Se compone sobre BASE_URL para que
// siga funcionando si el portal se sirve colgado de un subdirectorio.
export const BRAIN_ASSETS_URL = `${import.meta.env.BASE_URL ?? '/'}brain`;
// Prefijo donde viven las consultas SQL en S3. Se puede reapuntar por entorno para
// ensayar una reorganización del bucket sin recompilar. El catálogo de consultas que
// cuelga de aquí está en `@shared/constants/sql-queries.ts`.
export const S3_QUERIES_BASE =
  import.meta.env.VITE_S3_QUERIES_BASE ??
  'https://clickpalmv2.s3.us-west-2.amazonaws.com/Resources/QuerysCustom/';
